jQuery("#pr-reviewsnippet").on(
  "click",
  ".pr-snippet-review-count",
  function (e) {
    jQuery("#tab-title-reviews a").trigger("click");
    jQuery("html, body").animate(
      {
        scrollTop: jQuery("#tab-title-reviews").offset().top - 30,
      },
      0
    );
  }
);
